import { ActionBus, Secret, GameListener, GameState } from 'game-logic';
import { UxGameActions, UxGameListener } from './ux-game-listener';

export abstract class BaseUxGameListener implements UxGameListener, GameListener {
  public get gameActions() {
    return this.gameActionBus;
  }

  private gameActionBus = new ActionBus<UxGameActions>();
  private fetchSecrets: ((indexes: number[]) => Promise<Secret[]>) | null = null;

  public setSecretFetcher(fetcher: (indexes: number[]) => Promise<Secret[]>) {
    this.fetchSecrets = fetcher;
  }

  onGameLoaded(): void {
    this.gameActionBus.emit('onGameLoaded');
  }

  async onStartGame(): Promise<void> {
    this.gameActionBus.emit('onStartGame');
  }

  onScoreChange(score: number): void {
    this.gameActionBus.emit('onScoreChange', { score });
  }

  onNewMove(moves: string[]): void {
    this.gameActionBus.emit('onNewMove', { moves });
  }

  onGameStateChange(state: GameState): void {
    this.gameActionBus.emit('onGameStateChange', { state });
  }

  async onGameComplete(moves: string[], isComplete: boolean): Promise<void> {
    this.gameActionBus.emit('onGameComplete', { moves, isComplete });
  }

  async discloseSecrets(indexes: number[]): Promise<Secret[]> {
    if (!this.fetchSecrets) {
      throw new Error('fetchSecrets function has not set!');
    }
    return await this.fetchSecrets(indexes);
  }
}
